/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seating_Severity_StrongInputs */



/**
* | output |
* | --- |
* | "Strong seating issue" |
*
* @param {Seating_Severity_StrongInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const seating_severity_strong = /** @type {((inputs?: Seating_Severity_StrongInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seating_Severity_StrongInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Problème de placement majeur")
	if (locale === "es") return /** @type {LocalizedString} */ ("Problema de asientos grave")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Problema grave de alocação")
	if (locale === "it") return /** @type {LocalizedString} */ ("Problema di disposizione grave")
	return /** @type {LocalizedString} */ ("Strong seating issue")
});